import '../less/root.less'
import SolutionModalCtrl from '../modals/solution/ctrl';
import ProductModal from '../modals/product/ctrl';
import ServiceModal from '../modals/service/ctrl';
import HelpModalCtrl from '../modals/help/ctrl';

export default class AppCtrl {
    constructor(ModalService, $rootScope, $scope, screenSaver) {
        this.ModalService = ModalService;

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.screenSaver = screenSaver;

        this.state = false;
        this.productFilter = '';

    }

    refresh() {
        location.reload();
    }

    openSolutionModal(id, selected) {

        if (!selected) {
            for (let el of this.$rootScope.categories) {
                el.selected = false;
            }

            this.$rootScope.$emit('categoryClear');
        }

        this.ModalService.showModal({
            template: require('../modals/solution/solution.html'),
            controller: SolutionModalCtrl,
            controllerAs: 'modal',
            inputs: {
                id: id,
                selected: selected
            },
            appendElement: angular.element(document.querySelector('#app-wrapper'))
        });
    }

    openNav() {
        this.$scope.$broadcast('openSidebar');
    }

    toggleState() {
        this.state = !this.state;
    }

    openStandAloneProduct(id) {
        let $rootScope = this.$rootScope;
        this.toggleState();

        this.ModalService.showModal({
            template: require('../modals/product/view.html'),
            controller: ProductModal,
            controllerAs: 'modal',
            inputs: {
                id: id,
                products: $rootScope.products
            },
            appendElement: angular.element(document.querySelector('#app-wrapper'))
        });
    }

    openStandAloneService(id) {
        let $rootScope = this.$rootScope;
        this.toggleState();

        this.ModalService.showModal({
            template: require('../modals/service/view.html'),
            controller: ServiceModal,
            controllerAs: 'modal',
            inputs: {
                id: id,
                services: $rootScope.services
            },
            appendElement: angular.element(document.querySelector('#app-wrapper'))
        });
    }

    openHelp() {
        this.toggleState();

        this.ModalService.showModal({
            template: require('../modals/help/view.html'),
            controller: HelpModalCtrl,
            controllerAs: 'modal',
            appendElement: angular.element(document.querySelector('#app-wrapper'))
        });
    }

    closeScreenSaver() {
        this.screenSaver.disable();
    }
}


// WEBPACK FOOTER //
// ./src/app/controllers/root.js